import React, { Component } from 'react'
import Forum from '../components/Forum'

export default class ForumRunPage extends Component {
    render() {
        return <div className="config-right-wrapper"><Forum.Page isAdmin={true} /></div>
    }
}
